namespace TabAurous.HR {
    export interface SalaryPackageDetailsForm {
        ComponentId: Serenity.ServiceLookupEditor;
        Amount: Serenity.DecimalEditor;
        Percentage: Serenity.DecimalEditor;
        Narration: Serenity.StringEditor;
    }

    export class SalaryPackageDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'HR.SalaryPackageDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SalaryPackageDetailsForm.init)  {
                SalaryPackageDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.ServiceLookupEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.StringEditor;

                Q.initFormType(SalaryPackageDetailsForm, [
                    'ComponentId', w0,
                    'Amount', w1,
                    'Percentage', w1,
                    'Narration', w2
                ]);
            }
        }
    }
}
